import React from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { 
  Upload01Icon, 
  Settings01Icon, 
  Mail01Icon, 
  Calendar01Icon 
} from "@hugeicons/core-free-icons"

// Icon component wrappers for constants
const CustommeetIcon = (props) => <HugeiconsIcon icon={Upload01Icon} {...props} />;
const FlozyLogo = (props) => <HugeiconsIcon icon={Settings01Icon} {...props} />;
const GmailIcon = (props) => <HugeiconsIcon icon={Mail01Icon} {...props} />;
const GooglemeetIcon = (props) => <HugeiconsIcon icon={Upload01Icon} {...props} />;
const OutlookIcon = (props) => <HugeiconsIcon icon={Mail01Icon} {...props} />;
const ZoomAppIconSmall = (props) => <HugeiconsIcon icon={Upload01Icon} {...props} />;
const EventOnetoOneIcon = (props) => <HugeiconsIcon icon={Calendar01Icon} {...props} />;

export const homePageContent = {
    welcomeText: "Hi, Hello Welcome!"
}

export const userPageContent = {
    userList: "User List "
}

export const DEFAULT_FILTERS = [
    {"key": "Active", "value":"Active"},
    {"key": "Completed", "value":"Completed"},
    {"key": "Deleted", "value":"Deleted"},
]
export const CLIENT_FILTERS = [
    {"key": "status", "value":"Status"},
    {"key": "tags", "value":"Tags"}
]
export const STATUS = "status";

export const TAGS = "tags";

export const infoBarsContent = {
    projectScale: `Want to join the 8 week Live Project Scale Mentorship?`,
    expiry: "Your agency plan has expired. Kindly pay your invoice as soon as possible to continue enjoying our services."
}

export const infoBarsLinks = {
    projectScale: "https://www.agenciflow.com/project-scale"
}

export const taskNotesConstants = {
    MAX_FILE_SIZE: 2,
    SIZE_ALERT: "File size should be less than 2mb",
}

export const emailDefaultConstants = {
    INVITE_MAIL_DEFAULT_MESSAGES: `<div>Hello!</div>
                                    <div><br></div>
                                    <div>I’d like to invite you to join <b>[Flow/Client]</b> in the workspace <b>[Agency_Name]</b> to keep track of the work we do together..</div>
                                    <div><br></div>
                                    <div>Using this secure online system, you’ll keep track of our work, collaborate with our team, and stay up to date with [Agency_Name]! It gives a real-time view and is a great way to remain in sync.</div>
                                    <div><br></div>
                                    <div>Please click on the link below to access your account now.</div>
                                    <div><br></div>
                                    <div>Looking forward to working together! 🙂</div>
                                    <div><br></div>
                                    <div>Best,</div>
                                    <div>[Agency_Name] team</div>`,
}

export const projectsPageConstants = {
    createProjects: {
        PAGE_TITLE_TEXT: "CREATE FLOW",
        PAGE_SUB_TITLE_TEXT: "Create a new flow for you and your team",
        FORM_TITLE_TEXT: "Basic Info",
        FORM_SUB_TITLE_TEXT: "About your flow",
        PROJECT_TITLE_TEXT: "Title",
        PROJECT_SUB_TITLE_TEXT: "Give the flow a catchy title",
        PROJECT_TITLE_PLACE_HOLDER: "Type it here...",
        PROJECT_BRIEF_TEXT: "Brief",
        PROJECT_BRIEF_SUB_TEXT: "Write a brief explaining what the flow is about",
        PROJECT_BRIEF_PLACE_HOLDER: "Type it here...",
        PROJECT_MEDIA_DELETE_DIALOG_TEXT: "Do you want to delete this file"
    }
}

export const chatPageConstants = {
    MESSAGE_LIMIT_COUNT: 20,
    SELECT_FILES_ALERT: "Please select some files first"
}

export const invoicePageConstant = {
    MAX_FILE_SIZE: 2,
    SIZE_ALERT: "File size should be less than 2mb",
}

export const iconSetArray = ["ai", "android", "apk", "css", "disc", "doc", "docs", "docx", "excel", "font", "iso", "js", "mp3", "mp4", "pdf", "php", "play", "ppt", "psd", "sql", "svg", "ttf", "txt", "vcf", "xls", "zip", 'xlsx', 'gif', 'csv']


export const countryList = [
    { label: 'United States', value: 'US' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'Canada', value: 'CA' },
    { label: 'Germany', value: 'DE' },
    { label: 'Australia', value: 'AU' },
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Åland Islands', value: 'AX' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'AndorrA', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Anguilla', value: 'AI' },
    { label: 'Antarctica', value: 'AQ' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Aruba', value: 'AW' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bermuda', value: 'BM' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Bouvet Island', value: 'BV' },
    { label: 'Brazil', value: 'BR' },
    { label: 'British Indian Ocean Territory', value: 'IO' },
    { label: 'Brunei Darussalam', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Cape Verde', value: 'CV' },
    { label: 'Cayman Islands', value: 'KY' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Christmas Island', value: 'CX' },
    { label: 'Cocos (Keeling) Islands', value: 'CC' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'Congo, The Democratic Republic of the', value: 'CD' },
    { label: 'Cook Islands', value: 'CK' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Cote D\'Ivoire', value: 'CI' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Falkland Islands (Malvinas)', value: 'FK' },
    { label: 'Faroe Islands', value: 'FO' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'French Guiana', value: 'GF' },
    { label: 'French Polynesia', value: 'PF' },
    { label: 'French Southern Territories', value: 'TF' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Gibraltar', value: 'GI' },
    { label: 'Greece', value: 'GR' },
    { label: 'Greenland', value: 'GL' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guadeloupe', value: 'GP' },
    { label: 'Guam', value: 'GU' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guernsey', value: 'GG' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { label: 'Holy See (Vatican City State)', value: 'VA' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hong Kong', value: 'HK' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran, Islamic Republic Of', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Isle of Man', value: 'IM' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jersey', value: 'JE' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Korea, Democratic People\'S Republic of', value: 'KP' },
    { label: 'Korea, Republic of', value: 'KR' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Lao People\'S Democratic Republic', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libyan Arab Jamahiriya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Macao', value: 'MO' },
    { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Martinique', value: 'MQ' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mayotte', value: 'YT' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia, Federated States of', value: 'FM' },
    { label: 'Moldova, Republic of', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montserrat', value: 'MS' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'Netherlands Antilles', value: 'AN' },
    { label: 'New Caledonia', value: 'NC' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Niue', value: 'NU' },
    { label: 'Norfolk Island', value: 'NF' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Palestinian Territory, Occupied', value: 'PS' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Pitcairn', value: 'PN' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Reunion', value: 'RE' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russian Federation', value: 'RU' },
    { label: 'RWANDA', value: 'RW' },
    { label: 'Saint Helena', value: 'SH' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Pierre and Miquelon', value: 'PM' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia and Montenegro', value: 'CS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Svalbard and Jan Mayen', value: 'SJ' },
    { label: 'Swaziland', value: 'SZ' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syrian Arab Republic', value: 'SY' },
    { label: 'Taiwan, Province of China', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania, United Republic of', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tokelau', value: 'TK' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Turks and Caicos Islands', value: 'TC' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United States Minor Outlying Islands', value: 'UM' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Viet Nam', value: 'VN' },
    { label: 'Virgin Islands, British', value: 'VG' },
    { label: 'Virgin Islands, U.S.', value: 'VI' },
    { label: 'Wallis and Futuna', value: 'WF' },
    { label: 'Western Sahara', value: 'EH' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' }
];

export const currencyList = [
    {
        label: "US Dollar",
        value: "USD",
        symbol: "$"
    },
    {
        label: "Canadian Dollar",
        value: "CAD",
        symbol: "$"
    },
    {
        label: "Euro",
        value: "EUR",
        symbol: "€"
    },
    {
        label: "United Arab Emirates Dirham",
        value: "AED",
        symbol: "د.إ.‏"
    },
    {
        label: "Afghan Afghani",
        value: "AFN",
        symbol: "؋"
    },
    {
        label: "Albanian Lek",
        value: "ALL",
        symbol: "Lek"
    },
    {
        label: "Armenian Dram",
        value: "AMD",
        symbol: "դր."
    },
    {
        label: "Argentine Peso",
        value: "ARS",
        symbol: "$"
    },
    {
        label: "Australian Dollar",
        value: "AUD",
        symbol: "$"
    },
    {
        label: "Azerbaijani Manat",
        value: "AZN",
        symbol: "ман."
    },
    {
        label: "Bosnia-Herzegovina Convertible Mark",
        value: "BAM",
        symbol: "KM"
    },
    {
        label: "Bangladeshi Taka",
        value: "BDT",
        symbol: "৳"
    },
    {
        label: "Bulgarian Lev",
        value: "BGN",
        symbol: "лв."
    },
    {
        label: "Bahraini Dinar",
        value: "BHD",
        symbol: "د.ب.‏"
    },
    {
        label: "Burundian Franc",
        value: "BIF",
        symbol: "FBu"
    },
    {
        label: "Brunei Dollar",
        value: "BND",
        symbol: "$"
    },
    {
        label: "Bolivian Boliviano",
        value: "BOB",
        symbol: "Bs"
    },
    {
        label: "Brazilian Real",
        value: "BRL",
        symbol: "R$"
    },
    {
        label: "Botswanan Pula",
        value: "BWP",
        symbol: "P"
    },
    {
        label: "Belarusian Ruble",
        value: "BYR",
        symbol: "BYR"
    },
    {
        label: "Belize Dollar",
        value: "BZD",
        symbol: "$"
    },
    {
        label: "Congolese Franc",
        value: "CDF",
        symbol: "FrCD"
    },
    {
        label: "Swiss Franc",
        value: "CHF",
        symbol: "CHF"
    },
    {
        label: "Chilean Peso",
        value: "CLP",
        symbol: "$"
    },
    {
        label: "Chinese Yuan",
        value: "CNY",
        symbol: "CN¥"
    },
    {
        label: "Colombian Peso",
        value: "COP",
        symbol: "$"
    },
    {
        label: "Costa Rican Colón",
        value: "CRC",
        symbol: "₡"
    },
    {
        label: "Cape Verdean Escudo",
        value: "CVE",
        symbol: "CV$"
    },
    {
        label: "Czech Republic Koruna",
        value: "CZK",
        symbol: "Kč"
    },
    {
        label: "Djiboutian Franc",
        value: "DJF",
        symbol: "Fdj"
    },
    {
        label: "Danish Krone",
        value: "DKK",
        symbol: "kr"
    },
    {
        label: "Dominican Peso",
        value: "DOP",
        symbol: "RD$"
    },
    {
        label: "Algerian Dinar",
        value: "DZD",
        symbol: "د.ج.‏"
    },
    {
        label: "Estonian Kroon",
        value: "EEK",
        symbol: "kr"
    },
    {
        label: "Egyptian Pound",
        value: "EGP",
        symbol: "ج.م.‏"
    },
    {
        label: "Eritrean Nakfa",
        value: "ERN",
        symbol: "Nfk"
    },
    {
        label: "Ethiopian Birr",
        value: "ETB",
        symbol: "Br"
    },
    {
        label: "British Pound Sterling",
        value: "GBP",
        symbol: "£"
    },
    {
        label: "Georgian Lari",
        value: "GEL",
        symbol: "GEL"
    },
    {
        label: "Ghanaian Cedi",
        value: "GHS",
        symbol: "GH₵"
    },
    {
        label: "Guinean Franc",
        value: "GNF",
        symbol: "FG"
    },
    {
        label: "Guatemalan Quetzal",
        value: "GTQ",
        symbol: "Q"
    },
    {
        label: "Hong Kong Dollar",
        value: "HKD",
        symbol: "$"
    },
    {
        label: "Honduran Lempira",
        value: "HNL",
        symbol: "L"
    },
    {
        label: "Croatian Kuna",
        value: "HRK",
        symbol: "kn"
    },
    {
        label: "Hungarian Forint",
        value: "HUF",
        symbol: "Ft"
    },
    {
        label: "Indonesian Rupiah",
        value: "IDR",
        symbol: "Rp"
    },
    {
        label: "Israeli New Sheqel",
        value: "ILS",
        symbol: "₪"
    },
    {
        label: "Indian Rupee",
        value: "INR",
        symbol: "₹"
    },
    {
        label: "Iraqi Dinar",
        value: "IQD",
        symbol: "د.ع.‏"
    },
    {
        label: "Iranian Rial",
        value: "IRR",
        symbol: "﷼"
    },
    {
        label: "Icelandic Króna",
        value: "ISK",
        symbol: "kr"
    },
    {
        label: "Jamaican Dollar",
        value: "JMD",
        symbol: "$"
    },
    {
        label: "Jordanian Dinar",
        value: "JOD",
        symbol: "د.أ.‏"
    },
    {
        label: "Japanese Yen",
        value: "JPY",
        symbol: "￥"
    },
    {
        label: "Kenyan Shilling",
        value: "KES",
        symbol: "Ksh"
    },
    {
        label: "Cambodian Riel",
        value: "KHR",
        symbol: "៛"
    },
    {
        label: "Comorian Franc",
        value: "KMF",
        symbol: "FC"
    },
    {
        label: "South Korean Won",
        value: "KRW",
        symbol: "₩"
    },
    {
        label: "Kuwaiti Dinar",
        value: "KWD",
        symbol: "د.ك.‏"
    },
    {
        label: "Kazakhstani Tenge",
        value: "KZT",
        symbol: "тңг."
    },
    {
        label: "Lebanese Pound",
        value: "LBP",
        symbol: "ل.ل.‏"
    },
    {
        label: "Sri Lankan Rupee",
        value: "LKR",
        symbol: "SL Re"
    },
    {
        label: "Lithuanian Litas",
        value: "LTL",
        symbol: "Lt"
    },
    {
        label: "Latvian Lats",
        value: "LVL",
        symbol: "Ls"
    },
    {
        label: "Libyan Dinar",
        value: "LYD",
        symbol: "د.ل.‏"
    },
    {
        label: "Moroccan Dirham",
        value: "MAD",
        symbol: "د.م.‏"
    },
    {
        label: "Moldovan Leu",
        value: "MDL",
        symbol: "MDL"
    },
    {
        label: "Malagasy Ariary",
        value: "MGA",
        symbol: "MGA"
    },
    {
        label: "Macedonian Denar",
        value: "MKD",
        symbol: "MKD"
    },
    {
        label: "Myanma Kyat",
        value: "MMK",
        symbol: "K"
    },
    {
        label: "Macanese Pataca",
        value: "MOP",
        symbol: "MOP$"
    },
    {
        label: "Mauritian Rupee",
        value: "MUR",
        symbol: "MURs"
    },
    {
        label: "Mexican Peso",
        value: "MXN",
        symbol: "$"
    },
    {
        label: "Malaysian Ringgit",
        value: "MYR",
        symbol: "RM"
    },
    {
        label: "Mozambican Metical",
        value: "MZN",
        symbol: "MTn"
    },
    {
        label: "Namibian Dollar",
        value: "NAD",
        symbol: "N$"
    },
    {
        label: "Nigerian Naira",
        value: "NGN",
        symbol: "₦"
    },
    {
        label: "Nicaraguan Córdoba",
        value: "NIO",
        symbol: "C$"
    },
    {
        label: "Norwegian Krone",
        value: "NOK",
        symbol: "kr"
    },
    {
        label: "Nepalese Rupee",
        value: "NPR",
        symbol: "नेरू"
    },
    {
        label: "New Zealand Dollar",
        value: "NZD",
        symbol: "$"
    },
    {
        label: "Omani Rial",
        value: "OMR",
        symbol: "ر.ع.‏"
    },
    {
        label: "Panamanian Balboa",
        value: "PAB",
        symbol: "B/."
    },
    {
        label: "Peruvian Nuevo Sol",
        value: "PEN",
        symbol: "S/."
    },
    {
        label: "Philippine Peso",
        value: "PHP",
        symbol: "₱"
    },
    {
        label: "Pakistani Rupee",
        value: "PKR",
        symbol: "₨"
    },
    {
        label: "Polish Zloty",
        value: "PLN",
        symbol: "zł"
    },
    {
        label: "Paraguayan Guarani",
        value: "PYG",
        symbol: "₲"
    },
    {
        label: "Qatari Rial",
        value: "QAR",
        symbol: "ر.ق.‏"
    },
    {
        label: "Romanian Leu",
        value: "RON",
        symbol: "RON"
    },
    {
        label: "Serbian Dinar",
        value: "RSD",
        symbol: "дин."
    },
    {
        label: "Russian Ruble",
        value: "RUB",
        symbol: "руб."
    },
    {
        label: "Rwandan Franc",
        value: "RWF",
        symbol: "FR"
    },
    {
        label: "Saudi Riyal",
        value: "SAR",
        symbol: "ر.س.‏"
    },
    {
        label: "Sudanese Pound",
        value: "SDG",
        symbol: "SDG"
    },
    {
        label: "Swedish Krona",
        value: "SEK",
        symbol: "kr"
    },
    {
        label: "Singapore Dollar",
        value: "SGD",
        symbol: "$"
    },
    {
        label: "Somali Shilling",
        value: "SOS",
        symbol: "Ssh"
    },
    {
        label: "Syrian Pound",
        value: "SYP",
        symbol: "ل.س.‏"
    },
    {
        label: "Thai Baht",
        value: "THB",
        symbol: "฿"
    },
    {
        label: "Tunisian Dinar",
        value: "TND",
        symbol: "د.ت.‏"
    },
    {
        label: "Tongan Paʻanga",
        value: "TOP",
        symbol: "T$"
    },
    {
        label: "Turkish Lira",
        value: "TRY",
        symbol: "TL"
    },
    {
        label: "Trinidad and Tobago Dollar",
        value: "TTD",
        symbol: "$"
    },
    {
        label: "New Taiwan Dollar",
        value: "TWD",
        symbol: "NT$"
    },
    {
        label: "Tanzanian Shilling",
        value: "TZS",
        symbol: "TSh"
    },
    {
        label: "Ukrainian Hryvnia",
        value: "UAH",
        symbol: "₴"
    },
    {
        label: "Ugandan Shilling",
        value: "UGX",
        symbol: "USh"
    },
    {
        label: "Uruguayan Peso",
        value: "UYU",
        symbol: "$"
    },
    {
        label: "Uzbekistan Som",
        value: "UZS",
        symbol: "UZS"
    },
    {
        label: "Venezuelan Bolívar",
        value: "VEF",
        symbol: "Bs.F."
    },
    {
        label: "Vietnamese Dong",
        value: "VND",
        symbol: "₫"
    },
    {
        label: "CFA Franc BEAC",
        value: "XAF",
        symbol: "FCFA"
    },
    {
        label: "CFA Franc BCEAO",
        value: "XOF",
        symbol: "CFA"
    },
    {
        label: "Yemeni Rial",
        value: "YER",
        symbol: "ر.ي.‏"
    },
    {
        label: "South African Rand",
        value: "ZAR",
        symbol: "R"
    },
    {
        label: "Zambian Kwacha",
        value: "ZMK",
        symbol: "ZK"
    }
]

export const agencyCategory = [
    {
        label: "Search engine optimization (SEO)",
        value: "Search engine optimization (SEO)"
    },
    { label: "Social media agencies", value: "Social media agencies" },
    { label: "Digital Marketing", value: "Digital Marketing" },
    { label: "Agency Types", value: "Agency Types" },
    { label: "Paid Ads Marketing", value: "Paid Ads Marketing" },
    { label: "Lead Generation", value: "Lead Generation" },
    { label: "Video production", value: "Video production" },
    { label: "Content marketing", value: "Content marketing" },
    { label: "Influencer marketing", value: "Influencer marketing" },
    { label: "Email marketing", value: "Email marketing" },
    { label: "Web design", value: "Web design" },
    { label: "Affiliate marketing", value: "Affiliate marketing" },
    { label: "Graphic design", value: "Graphic design" },
    { label: "Others", value: "Others" },
    { label: "Branding", value: "Branding" },
    { label: "Public relations", value: "Public relations" },
    { label: "Event planning", value: "Event planning" },
    { label: "Recruitment", value: "Recruitment" },
    { label: "Mobile Marketing", value: "Mobile Marketing" },
    { label: "Public Affairs", value: "Public Affairs" },
    { label: "Integrated marketing", value: "Integrated marketing" },
    { label: "Market research", value: "Market research" },
    { label: "Coaching", value: "Coaching" },
    { label: "Talent", value: "Talent" },
    { label: "Interior design", value: "Interior design" },
    { label: "Travel", value: "Travel" },
    { label: "Legal", value: "Legal" },
    { label: "Accounting", value: "Accounting" },
    { label: "Architecture", value: "Architecture" },
    { label: "Translation", value: "Translation" },
    { label: "Environmental consulting", value: "Environmental consulting" },
    { label: "industry", value: "industry" },
    { label: "industry", value: "construction" },
    { label: "design", value: "design" },
    { label: "it", value: "iT" },
    { label: "automobile", value: "automobile" },
    { label: "education", value: "education" }
];

export const defaultUserRole = Object.freeze({
    "role": 2,
    "pjt": [1],
    "cli": [1],
    "dash": [1],
    "profile": [1],
    "cHub": [1],
    "boards": [1],
    "type": "emp",
})

export const URL_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

export const MAX_FILE_UPLOAD_SIZE = 20161520 //20 MB

export const REPEAT_OPTIONS = [
    { value: "1", label: "Daily" },
    { value: "2", label: "Weekly" },
    { value: "3", label: "Monthly" },
    { value: "4", label: "Yearly" }
]

export const DAY_OPTIONS = [
    { value: "1", label: "Sun" },
    { value: "2", label: "Mon" },
    { value: "3", label: "Tue" },
    { value: "4", label: "Wed" },
    { value: "5", label: "Thu" },
    { value: "6", label: "Fri" },
    { value: "7", label: "Sat" },
]

export const WEEK_OPTIONS = [
    { value: "1", label: "1st" },
    { value: "2", label: "2nd" },
    { value: "3", label: "3rd" },
    { value: "4", label: "4th" },
    { value: "5", label: "5th" },
    { value: "6", label: "Last" },
]

export const TASK_WEEK_OPTIONS = [
    { value: "1", label: "1st" },
    { value: "2", label: "2nd" },
    { value: "3", label: "3rd" },
    { value: "4", label: "4th" },
    { value: "5", label: "5th" },
    { value: "6", label: "Last" },
]

export const MONTH_OPTIONS = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
]

export const END_TYPES = [
    { "value": "1", "label": "Never" },
    { "value": "2", "label": "On" },
    { "value": "3", "label": "After" }
]

export const MONTH=[
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ]

  export const TIME_ZONE_OPTIONS = [
    {
        "label": "DST",
        "value": "DST",
        "offset": -12
    },
    {
        "label": "U",
        "value": "U",
        "offset": -11
    },
    {
        "label": "HST",
        "value": "HST",
        "offset": -10
    },
    {
        "label": "AKDT",
        "value": "AKDT",
        "offset": -8
    },
    {
        "label": "PDT",
        "value": "PDT",
        "offset": -7
    },
    {
        "label": "PST",
        "value": "PST",
        "offset": -8
    },
    {
        "label": "UMST",
        "value": "UMST",
        "offset": -7
    },
    {
        "label": "MDT",
        "value": "MDT",
        "offset": -6
    },
    {
        "label": "CAST",
        "value": "CAST",
        "offset": -6
    },
    {
        "label": "CDT",
        "value": "CDT",
        "offset": -5
    },
    {
        "label": "CCST",
        "value": "CCST",
        "offset": -6
    },
    {
        "label": "SPST",
        "value": "SPST",
        "offset": -5
    },
    {
        "label": "EST",
        "value": "EST",
        "offset": -5
    },
    {
        "label": "EDT",
        "value": "EDT",
        "offset": -4
    },
    {
        "label": "UEDT",
        "value": "UEDT",
        "offset": -5
    },
    {
        "label": "VST",
        "value": "VST",
        "offset": -4.5
    },
    {
        "label": "PYT",
        "value": "PYT",
        "offset": -4
    },
    {
        "label": "ADT",
        "value": "ADT",
        "offset": -3
    },
    {
        "label": "CBST",
        "value": "CBST",
        "offset": -4
    },
    {
        "label": "SWST",
        "value": "SWST",
        "offset": -4
    },
    {
        "label": "PSST",
        "value": "PSST",
        "offset": -4
    },
    {
        "label": "NDT",
        "value": "NDT",
        "offset": -2.5
    },
    {
        "label": "ESAST",
        "value": "ESAST",
        "offset": -3
    },
    {
        "label": "AST",
        "value": "AST",
        "offset": -3
    },
    {
        "label": "SEST",
        "value": "SEST",
        "offset": -3
    },
    {
        "label": "GDT",
        "value": "GDT",
        "offset": -3
    },
    {
        "label": "MST",
        "value": "MST",
        "offset": -3
    },
    {
        "label": "BST",
        "value": "BST",
        "offset": -3
    },
    {
        "label": "U",
        "value": "U",
        "offset": -2
    },
    {
        "label": "MDT",
        "value": "MDT",
        "offset": -1
    },
    {
        "label": "ADT",
        "value": "ADT",
        "offset": 0
    },
    {
        "label": "CVST",
        "value": "CVST",
        "offset": -1
    },
    {
        "label": "MDT",
        "value": "MDT",
        "offset": 1
    },
    {
        "label": "UTC",
        "value": "UTC",
        "offset": 0
    },
    {
        "label": "GMT",
        "value": "GMT",
        "offset": 0
    },
    {
        "label": "BST",
        "value": "BST",
        "offset": 1
    },
    {
        "label": "GDT",
        "value": "GDT",
        "offset": 1
    },
    {
        "label": "GST",
        "value": "GST",
        "offset": 0
    },
    {
        "label": "WEDT",
        "value": "WEDT",
        "offset": 2
    },
    {
        "label": "CEDT",
        "value": "CEDT",
        "offset": 2
    },
    {
        "label": "RDT",
        "value": "RDT",
        "offset": 2
    },
    {
        "label": "CEDT",
        "value": "CEDT",
        "offset": 2
    },
    {
        "label": "WCAST",
        "value": "WCAST",
        "offset": 1
    },
    {
        "label": "NST",
        "value": "NST",
        "offset": 1
    },
    {
        "label": "GDT",
        "value": "GDT",
        "offset": 3
    },
    {
        "label": "MEDT",
        "value": "MEDT",
        "offset": 3
    },
    {
        "label": "EST",
        "value": "EST",
        "offset": 2
    },
    {
        "label": "SDT",
        "value": "SDT",
        "offset": 3
    },
    {
        "label": "EEDT",
        "value": "EEDT",
        "offset": 3
    },
    {
        "label": "SAST",
        "value": "SAST",
        "offset": 2
    },
    {
        "label": "FDT",
        "value": "FDT",
        "offset": 3
    },
    {
        "label": "TDT",
        "value": "TDT",
        "offset": 3
    },
    {
        "label": "JDT",
        "value": "JDT",
        "offset": 3
    },
    {
        "label": "LST",
        "value": "LST",
        "offset": 2
    },
    {
        "label": "JST",
        "value": "JST",
        "offset": 3
    },
    {
        "label": "AST",
        "value": "AST",
        "offset": 3
    },
    {
        "label": "KST",
        "value": "KST",
        "offset": 3
    },
    {
        "label": "AST",
        "value": "AST",
        "offset": 3
    },
    {
        "label": "EAST",
        "value": "EAST",
        "offset": 3
    },
    {
        "label": "MSK",
        "value": "MSK",
        "offset": 3
    },
    {
        "label": "SAMT",
        "value": "SAMT",
        "offset": 4
    },
    {
        "label": "IDT",
        "value": "IDT",
        "offset": 4.5
    },
    {
        "label": "AST",
        "value": "AST",
        "offset": 4
    },
    {
        "label": "ADT",
        "value": "ADT",
        "offset": 5
    },
    {
        "label": "MST",
        "value": "MST",
        "offset": 4
    },
    {
        "label": "GET",
        "value": "GET",
        "offset": 4
    },
    {
        "label": "CST",
        "value": "CST",
        "offset": 4
    },
    {
        "label": "AST",
        "value": "AST",
        "offset": 4.5
    },
    {
        "label": "WAST",
        "value": "WAST",
        "offset": 5
    },
    {
        "label": "YEKT",
        "value": "YEKT",
        "offset": 5
    },
    {
        "label": "PKT",
        "value": "PKT",
        "offset": 5
    },
    {
        "label": "IST",
        "value": "IST",
        "offset": 5.5
    },
    {
        "label": "SLST",
        "value": "SLST",
        "offset": 5.5
    },
    {
        "label": "NST",
        "value": "NST",
        "offset": 5.75
    },
    {
        "label": "CAST",
        "value": "CAST",
        "offset": 6
    },
    {
        "label": "BST",
        "value": "BST",
        "offset": 6
    },
    {
        "label": "MST",
        "value": "MST",
        "offset": 6.5
    },
    {
        "label": "SAST",
        "value": "SAST",
        "offset": 7
    },
    {
        "label": "NCAST",
        "value": "NCAST",
        "offset": 7
    },
    {
        "label": "CST",
        "value": "CST",
        "offset": 8
    },
    {
        "label": "NAST",
        "value": "NAST",
        "offset": 8
    },
    {
        "label": "MPST",
        "value": "MPST",
        "offset": 8
    },
    {
        "label": "WAST",
        "value": "WAST",
        "offset": 8
    },
    {
        "label": "TST",
        "value": "TST",
        "offset": 8
    },
    {
        "label": "UST",
        "value": "UST",
        "offset": 8
    },
    {
        "label": "NAEST",
        "value": "NAEST",
        "offset": 8
    },
    {
        "label": "JST",
        "value": "JST",
        "offset": 9
    },
    {
        "label": "KST",
        "value": "KST",
        "offset": 9
    },
    {
        "label": "CAST",
        "value": "CAST",
        "offset": 9.5
    },
    {
        "label": "ACST",
        "value": "ACST",
        "offset": 9.5
    },
    {
        "label": "EAST",
        "value": "EAST",
        "offset": 10
    },
    {
        "label": "AEST",
        "value": "AEST",
        "offset": 10
    },
    {
        "label": "WPST",
        "value": "WPST",
        "offset": 10
    },
    {
        "label": "TST",
        "value": "TST",
        "offset": 10
    },
    {
        "label": "YST",
        "value": "YST",
        "offset": 9
    },
    {
        "label": "CPST",
        "value": "CPST",
        "offset": 11
    },
    {
        "label": "VST",
        "value": "VST",
        "offset": 11
    },
    {
        "label": "NZST",
        "value": "NZST",
        "offset": 12
    },
    {
        "label": "U",
        "value": "U",
        "offset": 12
    },
    {
        "label": "FST",
        "value": "FST",
        "offset": 12
    },
    {
        "label": "MST",
        "value": "MST",
        "offset": 12
    },
    {
        "label": "KDT",
        "value": "KDT",
        "offset": 13
    },
    {
        "label": "TST",
        "value": "TST",
        "offset": 13
    },
    {
        "label": "SST",
        "value": "SST",
        "offset": 13
    }
  ]

  export const FUNNEL_STEP_TYPES = {
    PROPOSAL: {
      label: "Proposal",
      step_type: "PROPOSAL",
    },
    CONTRACT: {
      label: "Contract",
      step_type: "CONTRACT",
    },
    FLOZY_SPACE: {
      label: "Flozy space",
      step_type: "FLOZY_SPACE",
    },
    WELCOME_VIDEO: {
      label: "Welcome Video",
      step_type: "WELCOME_VIDEO",
    },
    PAGE: {
      label: "Page",
      step_type: "PAGE",
    },

    FORMS: {
      label: "Forms",
      step_type: "FORMS",
    },

    // SIGN_UP: {
    //     label: "Sign up",
    //     step_type: "SIGN_UP"
    // }
  };
  
export const URL_PROTOCOL_REGEX = '^(http|https):\/\/';
export const ScheduleManagement = {
    SCHEDULE_MANAGEMENT: 'Schedule Management',
    SCHEDULE_MESSAGE: 'Schedule Message',
    CHAT_WORKFLOW: 'Chat Workflow',
    ADD_MESSAGE:'Add Message',
    ADD_MESSAGE_TITLE_PLACEHOLDER:'Enter title for this schedule message...',
    ADD_MESSAGE_PLACEHOLDER:'Write your message...',
    MESSAGE: 'Message',
    DATE_ERROR: 'Start date must be less than end date'
}

export const TIME_OPTIONS = [
    { label: "12:00 AM", value: "12:00 AM", filter: "12 AM", time: 0 },
    { label: "12:30 AM", value: "12:30 AM", filter: "12 AM", time: 30 },
    { label: "01:00 AM", value: "01:00 AM", filter: "01 AM", time: 0 },
    { label: "01:30 AM", value: "01:30 AM", filter: "01 AM", time: 30 },
    { label: "02:00 AM", value: "02:00 AM", filter: "02 AM", time: 0 },
    { label: "02:30 AM", value: "02:30 AM", filter: "02 AM", time: 30 },
    { label: "03:00 AM", value: "03:00 AM", filter: "03 AM", time: 0 },
    { label: "03:30 AM", value: "03:30 AM", filter: "03 AM", time: 30 },
    { label: "04:00 AM", value: "04:00 AM", filter: "04 AM", time: 0 },
    { label: "04:30 AM", value: "04:30 AM", filter: "04 AM", time: 30 },
    { label: "05:00 AM", value: "05:00 AM", filter: "05 AM", time: 0 },
    { label: "05:30 AM", value: "05:30 AM", filter: "05 AM", time: 30 },
    { label: "06:00 AM", value: "06:00 AM", filter: "06 AM", time: 0 },
    { label: "06:30 AM", value: "06:30 AM", filter: "06 AM", time: 30 },
    { label: "07:00 AM", value: "07:00 AM", filter: "07 AM", time: 0 },
    { label: "07:30 AM", value: "07:30 AM", filter: "07 AM", time: 30 },
    { label: "08:00 AM", value: "08:00 AM", filter: "08 AM", time: 0 },
    { label: "08:30 AM", value: "08:30 AM", filter: "08 AM", time: 30 },
    { label: "09:00 AM", value: "09:00 AM", filter: "09 AM", time: 0 },
    { label: "09:30 AM", value: "09:30 AM", filter: "09 AM", time: 30 },
    { label: "10:00 AM", value: "10:00 AM", filter: "10 AM", time: 0 },
    { label: "10:30 AM", value: "10:30 AM", filter: "10 AM", time: 30 },
    { label: "11:00 AM", value: "11:00 AM", filter: "11 AM", time: 0 },
    { label: "11:30 AM", value: "11:30 AM", filter: "11 AM", time: 30 },
    { label: "12:00 PM", value: "12:00 PM", filter: "12 PM", time: 0 },
    { label: "12:30 PM", value: "12:30 PM", filter: "12 PM", time: 30 },
    { label: "01:00 PM", value: "01:00 PM", filter: "01 PM", time: 0 },
    { label: "01:30 PM", value: "01:30 PM", filter: "01 PM", time: 30 },
    { label: "02:00 PM", value: "02:00 PM", filter: "02 PM", time: 0 },
    { label: "02:30 PM", value: "02:30 PM", filter: "02 PM", time: 30 },
    { label: "03:00 PM", value: "03:00 PM", filter: "03 PM", time: 0 },
    { label: "03:30 PM", value: "03:30 PM", filter: "03 PM", time: 30 },
    { label: "04:00 PM", value: "04:00 PM", filter: "04 PM", time: 0 },
    { label: "04:30 PM", value: "04:30 PM", filter: "04 PM", time: 30 },
    { label: "05:00 PM", value: "05:00 PM", filter: "05 PM", time: 0 },
    { label: "05:30 PM", value: "05:30 PM", filter: "05 PM", time: 30 },
    { label: "06:00 PM", value: "06:00 PM", filter: "06 PM", time: 0 },
    { label: "06:30 PM", value: "06:30 PM", filter: "06 PM", time: 30 },
    { label: "07:00 PM", value: "07:00 PM", filter: "07 PM", time: 0 },
    { label: "07:30 PM", value: "07:30 PM", filter: "07 PM", time: 30 },
    { label: "08:00 PM", value: "08:00 PM", filter: "08 PM", time: 0 },
    { label: "08:30 PM", value: "08:30 PM", filter: "08 PM", time: 30 },
    { label: "09:00 PM", value: "09:00 PM", filter: "09 PM", time: 0 },
    { label: "09:30 PM", value: "09:30 PM", filter: "09 PM", time: 30 },
    { label: "10:00 PM", value: "10:00 PM", filter: "10 PM", time: 0 },
    { label: "10:30 PM", value: "10:30 PM", filter: "10 PM", time: 30 },
    { label: "11:00 PM", value: "11:00 PM", filter: "11 PM", time: 0 },
    { label: "11:30 PM", value: "11:30 PM", filter: "11 PM", time: 30 },
]

export const TIME_OPTIONS_EVENT = [
    { label: "12:00 AM", value: "12:00 AM", filter: "12 AM", time: 0, },
    { label: "12:15 AM", value: "12:15 AM", filter: "12 AM", time: 15, },
    { label: "12:30 AM", value: "12:30 AM", filter: "12 AM", time: 30, },
    { label: "12:45 AM", value: "12:45 AM", filter: "12 AM", time: 45, },
    { label: "01:00 AM", value: "01:00 AM", filter: "01 AM", time: 0, },
    { label: "01:15 AM", value: "01:15 AM", filter: "01 AM", time: 15, },
    { label: "01:30 AM", value: "01:30 AM", filter: "01 AM", time: 30, },
    { label: "01:45 AM", value: "01:45 AM", filter: "01 AM", time: 45, },
    { label: "02:00 AM", value: "02:00 AM", filter: "02 AM", time: 0, },
    { label: "02:15 AM", value: "02:15 AM", filter: "02 AM", time: 15, },
    { label: "02:30 AM", value: "02:30 AM", filter: "02 AM", time: 30, },
    { label: "02:45 AM", value: "02:45 AM", filter: "02 AM", time: 45, },
    { label: "03:00 AM", value: "03:00 AM", filter: "03 AM", time: 0, },
    { label: "03:15 AM", value: "03:15 AM", filter: "03 AM", time: 15, },
    { label: "03:30 AM", value: "03:30 AM", filter: "03 AM", time: 30, },
    { label: "03:45 AM", value: "03:45 AM", filter: "03 AM", time: 45, },
    { label: "04:00 AM", value: "04:00 AM", filter: "04 AM", time: 0, },
    { label: "04:15 AM", value: "04:15 AM", filter: "04 AM", time: 15, },
    { label: "04:30 AM", value: "04:30 AM", filter: "04 AM", time: 30, },
    { label: "04:45 AM", value: "04:45 AM", filter: "04 AM", time: 45, },
    { label: "05:00 AM", value: "05:00 AM", filter: "05 AM", time: 0, },
    { label: "05:15 AM", value: "05:15 AM", filter: "05 AM", time: 15, },
    { label: "05:30 AM", value: "05:30 AM", filter: "05 AM", time: 30, },
    { label: "05:45 AM", value: "05:45 AM", filter: "05 AM", time: 45, },
    { label: "06:00 AM", value: "06:00 AM", filter: "06 AM", time: 0, },
    { label: "06:15 AM", value: "06:15 AM", filter: "06 AM", time: 15, },
    { label: "06:30 AM", value: "06:30 AM", filter: "06 AM", time: 30, },
    { label: "06:45 AM", value: "06:45 AM", filter: "06 AM", time: 45, },
    { label: "07:00 AM", value: "07:00 AM", filter: "07 AM", time: 0, },
    { label: "07:15 AM", value: "07:15 AM", filter: "07 AM", time: 15, },
    { label: "07:30 AM", value: "07:30 AM", filter: "07 AM", time: 30, },
    { label: "07:45 AM", value: "07:45 AM", filter: "07 AM", time: 45, },
    { label: "08:00 AM", value: "08:00 AM", filter: "08 AM", time: 0, },
    { label: "08:15 AM", value: "08:15 AM", filter: "08 AM", time: 15, },
    { label: "08:30 AM", value: "08:30 AM", filter: "08 AM", time: 30, },
    { label: "08:45 AM", value: "08:45 AM", filter: "08 AM", time: 45, },
    { label: "09:00 AM", value: "09:00 AM", filter: "09 AM", time: 0, },
    { label: "09:15 AM", value: "09:15 AM", filter: "09 AM", time: 15, },
    { label: "09:30 AM", value: "09:30 AM", filter: "09 AM", time: 30, },
    { label: "09:45 AM", value: "09:45 AM", filter: "09 AM", time: 45, },
    { label: "10:00 AM", value: "10:00 AM", filter: "10 AM", time: 0, },
    { label: "10:15 AM", value: "10:15 AM", filter: "10 AM", time: 15, },
    { label: "10:30 AM", value: "10:30 AM", filter: "10 AM", time: 30, },
    { label: "10:45 AM", value: "10:45 AM", filter: "10 AM", time: 45, },
    { label: "11:00 AM", value: "11:00 AM", filter: "11 AM", time: 0, },
    { label: "11:15 AM", value: "11:15 AM", filter: "11 AM", time: 15, },
    { label: "11:30 AM", value: "11:30 AM", filter: "11 AM", time: 30, },
    { label: "11:45 AM", value: "11:45 AM", filter: "11 AM", time: 45, },
    { label: "12:00 PM", value: "12:00 PM", filter: "12 PM", time: 0, },
    { label: "12:15 PM", value: "12:15 PM", filter: "12 PM", time: 15, },
    { label: "12:30 PM", value: "12:30 PM", filter: "12 PM", time: 30, },
    { label: "12:45 PM", value: "12:45 PM", filter: "12 PM", time: 45, },
    { label: "01:00 PM", value: "01:00 PM", filter: "01 PM", time: 0, },
    { label: "01:15 PM", value: "01:15 PM", filter: "01 PM", time: 15, },
    { label: "01:30 PM", value: "01:30 PM", filter: "01 PM", time: 30, },
    { label: "01:45 PM", value: "01:45 PM", filter: "01 PM", time: 45, },
    { label: "02:00 PM", value: "02:00 PM", filter: "02 PM", time: 0, },
    { label: "02:15 PM", value: "02:15 PM", filter: "02 PM", time: 15, },
    { label: "02:30 PM", value: "02:30 PM", filter: "02 PM", time: 30, },
    { label: "02:45 PM", value: "02:45 PM", filter: "02 PM", time: 45, },
    { label: "03:00 PM", value: "03:00 PM", filter: "03 PM", time: 0, },
    { label: "03:15 PM", value: "03:15 PM", filter: "03 PM", time: 15, },
    { label: "03:30 PM", value: "03:30 PM", filter: "03 PM", time: 30, },
    { label: "03:45 PM", value: "03:45 PM", filter: "03 PM", time: 45, },
    { label: "04:00 PM", value: "04:00 PM", filter: "04 PM", time: 0, },
    { label: "04:15 PM", value: "04:15 PM", filter: "04 PM", time: 15, },
    { label: "04:30 PM", value: "04:30 PM", filter: "04 PM", time: 30, },
    { label: "04:45 PM", value: "04:45 PM", filter: "04 PM", time: 45, },
    { label: "05:00 PM", value: "05:00 PM", filter: "05 PM", time: 0, },
    { label: "05:15 PM", value: "05:15 PM", filter: "05 PM", time: 15, },
    { label: "05:30 PM", value: "05:30 PM", filter: "05 PM", time: 30, },
    { label: "05:45 PM", value: "05:45 PM", filter: "05 PM", time: 45, },
    { label: "06:00 PM", value: "06:00 PM", filter: "06 PM", time: 0, },
    { label: "06:15 PM", value: "06:15 PM", filter: "06 PM", time: 15, },
    { label: "06:30 PM", value: "06:30 PM", filter: "06 PM", time: 30, },
    { label: "06:45 PM", value: "06:45 PM", filter: "06 PM", time: 45, },
    { label: "07:00 PM", value: "07:00 PM", filter: "07 PM", time: 0, },
    { label: "07:15 PM", value: "07:15 PM", filter: "07 PM", time: 15, },
    { label: "07:30 PM", value: "07:30 PM", filter: "07 PM", time: 30, },
    { label: "07:45 PM", value: "07:45 PM", filter: "07 PM", time: 45, },
    { label: "08:00 PM", value: "08:00 PM", filter: "08 PM", time: 0, },
    { label: "08:15 PM", value: "08:15 PM", filter: "08 PM", time: 15, },
    { label: "08:30 PM", value: "08:30 PM", filter: "08 PM", time: 30, },
    { label: "08:45 PM", value: "08:45 PM", filter: "08 PM", time: 45, },
    { label: "09:00 PM", value: "09:00 PM", filter: "09 PM", time: 0, },
    { label: "09:15 PM", value: "09:15 PM", filter: "09 PM", time: 15, },
    { label: "09:30 PM", value: "09:30 PM", filter: "09 PM", time: 30, },
    { label: "09:45 PM", value: "09:45 PM", filter: "09 PM", time: 45, },
    { label: "10:00 PM", value: "10:00 PM", filter: "10 PM", time: 0, },
    { label: "10:15 PM", value: "10:15 PM", filter: "10 PM", time: 15, },
    { label: "10:30 PM", value: "10:30 PM", filter: "10 PM", time: 30, },
    { label: "10:45 PM", value: "10:45 PM", filter: "10 PM", time: 45, },
    { label: "11:00 PM", value: "11:00 PM", filter: "11 PM", time: 0, },
    { label: "11:15 PM", value: "11:15 PM", filter: "11 PM", time: 15, },
    { label: "11:30 PM", value: "11:30 PM", filter: "11 PM", time: 30, },
    { label: "11:45 PM", value: "11:45 PM", filter: "11 PM", time: 45, },
]

export const emailTemplates = {
    template1: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1706678900887_template1.png",
    template2: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1706678963297_template2.png",
    templateDark1: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage%20/%20A4%20-%2065emailTempdark1.png",
    templateDark2: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage%20/%20A4%20-%2066emailTempdark2.png"
  };
 
export const APPOINTMENT_ONLINE_OPTIONS = [
    { value: "1", label: "Google Meet" },
    { value: "2", label: "Flozy" }
]

  export const flozySpaces = {
    flozySpacetemplate1: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage%20/%20rr.png",
    flozySpacetemplate2: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/22995/FLOWS/39742/Group%201707481441%20%283%29_1718348732443.png",
    flozySpaceDarkTemplate1:"https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/22995/FLOWS/39030/DarkEmailTemplate1.png_1715153063392",
    flozySpaceDarkTemplate2:"https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/22995/FLOWS/39030/DarkEmailTemplate2.jpg_1715153063395",
    flozySpacetemplatemobile2: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1162/FLOWS/5623/new%20mobile%20tem_1725261671396.png",
    flozySpacetemplatemobileDark2:"https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1162/FLOWS/5623/darktemplatemob_1725261775309.png"
  };


export const APPOINTMENT_PHONE_OPTIONS = [
    { value: "1", label: "I'll reach out to my invitee (Get user's contact number)" },
    { value: "2", label: "Invitee should call me (Provide my contact number)" }
]

export const TIME_OPTION = [
    { value: "1", label: "Minutes" },
    { value: "2", label: "Hour" },
    { value: "3", label: "Days" }
]

export const TIME_OPTIONS_1 = [
    { value: "1", label: "mins" },
    { value: "2", label: "hrs" },
    { value: "3", label: "days" }
]

export const DAY_OPTION = [
    { value: "1", label: "Days" },
    { value: "2", label: "Months" }
]

export const DAILY_LIMIT = [
    { value: "0", label: "No Limit" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" }
]

export const DAY_LIMIT = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" }
]

export const MODE_OPTIONS = [
    {value:1,label:'Web Conference',
    options:[
    {value:1, label:'Google Meet',logo:<GooglemeetIcon size={15}/>},
    {value:2, label:'Flozy Room',logo:<FlozyLogo size={15}/>},
    {value:3, label:'Custom Meet',logo:<CustommeetIcon size={15}/>},
    {value:4, label:'Zoom Meet',logo:<ZoomAppIconSmall size={15}/>},
    ]},
    {value:2,label:'Phone Call'},
    {value:3,label:'In Person Meeting'},
]

export const STATUS_OPTIONS = [
    { value: 1, label: "No Show" },
    { value: 2, label: "Done" },
    { value: 3, label: "Cancelled" },
    { value: 4, label: "Blocked" },
    { value: 0, label: "Confirmed" },
]

export const EVENT_TYPE=[
    {value:1,label:'One-One'},
    {value:2,label:'One-Group'}
]

export const EMAIL_SERVICE_PROVIDER = [
    { value: "gmail", label: "Gmail", Icon: GmailIcon },
    { value: "outlook", label: "Outlook", Icon: OutlookIcon },
    // { value: "godaddy", label: "Godaddy", Icon: GodaddyIcon },
    // { value: "yahoo", label: "", Icon: YahooIcon },
    { value: "other", label: "Other" },
]

export const EMAIL_SERVICE_PROVIDER_OAUTH = [
    { value: "gmail", label: "Gmail", Icon: GmailIcon },
]

export const MAP_BOARD_FIELDS = [
    { value: "list", label: "List *", required: true },
    { value: "task_title", label: "Card title *", required: true },
    { value: "created_on", label: <>Created on<span className="pl-1 fs-12 secondary1">(YYYY-MM-DD)</span></>, type: "date" },
    { value: "first_name", label: "First name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "job_title", label: "Job title" },
    { value: "tags", label: "Tag" },
    { value: "next_meeting", label: <>Next Meeting<span className="pl-1 fs-12 secondary1">(YYYY-MM-DD)</span></>, type: "date" },
    { value: "last_meeting", label: <>Last Meeting<span className="pl-1 fs-12 secondary1">(YYYY-MM-DD)</span></>, type: "date" },
    { value: "due_date", label: <>Due Date<span className="pl-1 fs-12 secondary1">(YYYY-MM-DD)</span></>, type: "date" },
    { value: "company", label: "Company" },
    { value: "task_status", label: "Status" },
    { value: "task_sub_status", label: "Sub Status" },
    { value: "estimated_value", label: "Estimated Value" },
    { value: "linked_in", label: "Linked In" },
    { value: "youtube", label: "YouTube" },
    { value: "tiktok", label: "Tiktok" },
    { value: "website", label: "Website" },
    { value: "revenue", label: "Revenue" },
    { value: "business", label: "Business" },
    { value: "company_website", label: "Company Website" },
    { value: "city", label: "City" },
    { value: "date_of_birth", label: "Date of Birth",type:"date" },
    { value: "gender", label: "Gender" },
    { value: "zip", label: "Zip" },
    { value: "location", label: "Location" },
    { value: "budget", label: "Budget" },
    { value: "facebook", label: "Facebook" },
    { value: "instagram", label: "Instagram" },
    { value: "twitter", label: "Twitter" },
    { value: "lead_source", label: "Lead Source" },
    { value: "country", label: "Country" },
    { value: "address", label: "Address" },
    { value: "industries", label: "Industries" },
    { value: "state", label: "State" },
    { value: "company_size", label: "Company Size" }
];

export const DEFAULT_USER_IMAGE = "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1278/FLOWS/4272/Avatar_1719225396621.png"

export const SignUpStepper = ['User Details'];

export const typeofBusiness = ['Agency', 'Coaching', 'Consulting', 'Service-based Business', 'Ecommerce', 'Software'];
export const industry = ['Marketing', 'Education', 'Healthcare', 'Finance', 'Technology', 'Retail'];
export const teamMembers = ['Just me', '1-5', '5-10', '11-20', '21-50', '51-100', '100+'];
export const noOfClients = ['None', '3-5', '5-10', '11-20', '21-50', '51-100', '100+'];
export const typeOfHelp = ['Improving client management', 'Streamlining team collaboration', 'Enhancing productivity', 'Increasing sales',];

export const globalSearch = "global_search";
export const Flows_clients_status = [{label :"Active", value:"active", key: 0},{label :"Completed", value:"completed", key: 1}];

export const menuSettings = [{key:"task", label:"Task"}, {key:"boards", label:"Boards"},{key:"media", label:"Media"},{key:"brain", label:"Brain"}]

export const fortuneTerms = "Sign me up for The Fortune Cookie Newsletter - 3 clever emails a week about AI, money, and scroll-stopping ideas."
